<template>
  <div
    class="text-left absolute w-full bg-white border-r border-l border-t border-b z-10"
    id="options-dropdown"
  >
    <div
      class="absolute right-0 p-2"
      v-on:click="$store.dispatch('aShowOptions', false)"
    >
      <Zondicon class="nav-icon w-4 cursor-pointer fill-current" icon="Close" />
    </div>
    <div>
      <ul class="bg-white text-center">
        <li v-if="!user">
          <div
              class="py-2 block text-gray-700 border-b"
              v-on:click="generalLinkClick('/login')"
          >
            Login
          </div>
        </li>
        <li v-if="!user">
          <div
              class="py-2 block text-gray-700 border-b"
              v-on:click="generalLinkClick('/login')"
          >
            Register
          </div>
        </li>
      </ul>
    </div>

    <div v-if="$route.query.book">
      <div class="cursor-pointer">
        <div
          class="px-3 py-2 block"
          v-on:click="generalLinkClick(`/admin/books/${book.id}/update`)"
        >
          Update Notebook
        </div>
        <div
            v-on:click="generalLinkClick(`/admin/books/create?parent_id=${book.id}`)"
            class="px-3 py-2 block"
        >
          Create Nested Notebook
        </div>
        <button
            :class="{ 'text-red-500': book.favorite }"
            class="w-full bg-white  border-b px-3 py-2 cursor-pointer red text-left text-gray-500"
            v-on:click.prevent="favoriteNote(book)"
        >
          <Zondicon class="w-4 h-4 fill-current" icon="StarFull" />
        </button>
        <div
            class="w-full bg-white  border-b px-3 py-2 cursor-pointer red text-left text-gray-500"
            v-if="bookIsProtectedAndLocked"
            v-on:click="lockNotebook"
        >
          Lock
        </div>
      </div>
    </div>
    <div v-else>
      <div class="cursor-pointer border-b">
        <div
            v-on:click="generalLinkClick('/admin/settings')"
            class="px-3 py-2 block"
        >
          Settings
        </div>
      </div>
    </div>

    <div v-if="note">
      <note-options-dropdown
        :closeMenu="
          () =>
            $store.dispatch('aShowOptions', { show: false, closeOthers: true })
        "
        :note="note"
      >
      </note-options-dropdown>
    </div>
    <div>
      <div class="cursor-pointer border-b px-3 py-2 block" v-if="user" v-on:click="logout">
        Logout
      </div>
    </div>
  </div>
</template>

<script>
import NoteOptionsDropdown from "./NoteOptionsDropdown";
import qs from "query-string";
import {API_URL} from "../../env";

export default {
  props: ["closeMenu"],
  components: {
    NoteOptionsDropdown
  },
  mounted() {
    // If the user clicks outside of the recent-notes, close the suggestions
    let searchBoxArea = document.getElementById("options-dropdown");
    searchBoxArea.addEventListener("click", this.handleInsideClick);
    document.body.addEventListener("click", this.handleOutsideClick);
  },
  beforeDestroy() {
    document.body.removeEventListener("click", this.handleOutsideClick);
  },
  methods: {
    generalLinkClick(uri) {
        this.$store.dispatch('aShowOptions', { show: false, closeOthers: true })
        this.$router.push({path: uri});
    },
    handleClick() {
      this.closeMenu();
    },
    handleOutsideClick() {
      const closeOthers = false;
      this.closeMenu(closeOthers);
    },
    handleInsideClick(e) {
      e.stopPropagation(); // this will stop propagation of this event to upper level
    },
    favoriteNote(note) {
      let noteCopy = Object.assign({}, note);
      noteCopy.favorite = !noteCopy.favorite;
      this.$store.dispatch("aFavoriteNote", noteCopy);
      this.closeMenu();
    },
    lockNotebook() {
        this.$store.dispatch('aLockBook', this.book.id).then((res) => {
          const queryString = qs.stringify(this.$route.query);
          const uri = `${API_URL}/admin/notes?${queryString}`;
          this.$store.dispatch("aGetNotesAdmin", {
            uri,
            notesFetchKey: queryString
          });
        })
    },
    async logout() {
      this.$loading(true);
      await this.$store.dispatch("LOGOUT");
      this.$loading(false);
      this.$router.push({ path: "/login" });
      this.$store.dispatch('aShowOptions', { show: false, closeOthers: true })
    },
  },

  computed: {
    user: function() {
      return this.$store.state.notes.user ? true : false;
    },
    isNoteOrBook() {
      return this.$route.query.book || this.$route.params.note;
    },
    book: function() {
      return this.$store.state.notes.book;
    },
    note() {
      // if we are on a single note page, return the single note
      if (this.$route.params.note) {
        const noteId = parseInt(this.$route.params.note);
        const index = this.$store.state.notes.notes.findIndex(
          x => x.id === noteId
        );
        return this.$store.state.notes.notes[index];
      }
      return null;
    },
    bookIsProtectedAndLocked() {
      let status = false;
      console.log('book vis', this.book, this.$store.state.notes.unlocked)
      if (this.book) {
        status = this.book.visibility === this.$store.state.notes.config.visibility.locked && this.$store.state.notes.unlocked.hasOwnProperty(this.book.id);
      }
      return status;
    },

  }
};
</script>
